if (document.querySelector(".ctype-ce_contact_search")) {
  import("./modules/contactSearch.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('[data-func="copy-iban"]')) {
  import("./modules/copyIban.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".donation-func")) {
  import("./modules/donation.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".ctype-ce_donation_progress")) {
  import("./modules/donationProgress.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".sticky-donation")) {
  import("./modules/donationSticky.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".flyout-menu")) {
  import("./modules/flyoutMenu.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".flyout-search")) {
  import("./modules/flyoutSearch.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".form-header-search")) {
  import("./modules/formHeaderSearch.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".lightbox")) {
  import("./modules/magnificPopup.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('[data-js="main-text-more"]')) {
  import("./modules/mainTextMore.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".interactive-map")) {
  import("./modules/map.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".modal")) {
  import("./modules/modal.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".news-list-view,.news-search-result")) {
  import("./modules/newsListView.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".panel")) {
  import("./modules/panel.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-container--1")) {
  import("./modules/swiper1.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-container--2")) {
  import("./modules/swiper2.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-container--21")) {
  import("./modules/swiper21.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-container--11")) {
  import("./modules/swiper11.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".teams-filter")) {
  import("./modules/teamsFilter.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('[data-bs-toggle="tooltip"]')) {
  import("./modules/tooltip.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector('[id^="twingle-public-embed-"]')) {
  import("./modules/twingle.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".js-player")) {
  import("./modules/asVideo.module.js").then((module) => {
    module.init();
  });
}

// =============================================================
// OTHER
// =============================================================
const updateHeaderHeight = () => {
  let headerHeight = document.querySelector("header").offsetHeight;
  document.querySelector("main").style.marginTop = headerHeight + "px";
};
updateHeaderHeight();

const checkUrlParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (
    urlParams.has("total") &&
    urlParams.has("consumption") &&
    urlParams.has("food") &&
    urlParams.has("living_hs") &&
    urlParams.has("living_pt") &&
    urlParams.has("mobility") &&
    urlParams.has("public_consumption") && !urlParams.has("tw_amount")
  ) {
    let tw_amount = 0;
    let total = urlParams.get("total");
    tw_amount = parseFloat(total) / 1000 * 22;
    urlParams.set("tw_amount", tw_amount);
    window.history.replaceState({}, "", `${location.pathname}?${urlParams}`);
    window.location.reload();
  }
};
checkUrlParams();

let attempts = 0;

const whenComplete = () => {
  if (attempts > 30) return;
  attempts += 1;
  if (document.readyState === "complete") {
    let intervalId = setInterval(() => {
      updateHeaderHeight();
    }, 50);

    window.onbeforeunload = function () {
      clearInterval(intervalId);
    };
  } else {
    setTimeout(function () {
      whenComplete();
    }, 400);
  }
};
whenComplete();

// =============================================================
// STYLES COMPLETE
// =============================================================
let styleAttempts = 0;
const stylesComplete = () => {
  if (styleAttempts > 30) return;
  styleAttempts += 1;
  if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
    document.querySelector("#sess").remove();
  } else {
    setTimeout(function () {
      stylesComplete();
    }, 300);
  }
};
stylesComplete();
